/**
 * Design tokens — approved "restrained field instrument" direction.
 * Single source of truth for color, typography, radius, and spacing.
 */

export const C = {
  bg:      '#0E1012',   // app background
  panel:   '#16191C',   // cards, field backgrounds
  panel2:  '#1C2024',   // elevated surfaces
  edge:    '#242A2F',   // borders, dividers
  ink:     '#ECEEF0',   // primary text
  ink2:    '#A8B0B6',   // secondary text, labels
  dim:     '#6B7278',   // tertiary, placeholders, unit ticks
  accent:  '#FF6B1A',   // hi-vis orange — use sparingly (see ACCENT_USES)
  danger:  '#FF453A',   // error banner
} as const;

/**
 * Accent is intentionally restricted to these locations only:
 *   1. Eyebrow left bar (4×11px)
 *   2. Focused field border
 *   3. Primary button fill
 *   4. Active bottom-nav item
 *   5. Formula card left stripe (3px)
 */
export const ACCENT_USES = C.accent;

export const FONT = {
  sans: 'Inter_400Regular',
  sansMed: 'Inter_500Medium',
  sansBold: 'Inter_700Bold',
  mono: 'JetBrainsMono_400Regular',
  monoBold: 'JetBrainsMono_700Bold',
} as const;

export const R = {
  field:  10,
  card:   14,
  button: 10,
  stripe: 3,
} as const;

export const SP = {
  xs:  4,
  sm:  8,
  md:  16,
  lg:  24,
  xl:  32,
} as const;
